import classnames from 'classnames';

import { COLUMNS_MAP } from '@/utils/columns';
import type { CSSProperties } from 'react';
import * as styles from './Products.css';
import type { ProductsElementProps } from './Products.types';
import { ProductSerializer } from './Serializer';

export function ProductsElement(props: ProductsElementProps) {
  const {
    element,
    children,
    attributes,
    className,
    isLive = false,
    paginateHasMorePosts,
    paginateFetchMorePosts,
    isLoading = false,
    onSearchQueryChange,
    isSearching,
    setIsSearching,
    handleNonDebouncedSearchQuery,
    handleResetSearchState,
    ...rest
  } = props;

  const {
    mobile_hide,
    desktop_hide,
    customAttributes,

    data,

    structureTiptapState,

    columns,
    gap,
    mobileGap,
    padding,
  } = element.attrs || {};

  const { products } = data || [];

  return (
    <div
      {...rest}
      {...customAttributes}
      className="relative flex flex-col"
      style={
        {
          width: '100%',
          '--products-gap': gap,
          '--products-mobile-gap': mobileGap,
          '--products-padding': padding,
        } as CSSProperties
      }
      {...attributes}
    >
      <div
        className={classnames(
          className,
          {
            'mobile:hidden': mobile_hide,
            'desktop:hidden': desktop_hide,
          },
          customAttributes?.className,
          'relative w-full grid',
          styles.productsGrid,
          COLUMNS_MAP[columns || '3'],
        )}
      >
        {products?.map((product) => {
          return (product?.product_variants || []).map((productVariant) => (
            <div key={product.id}>
              {isLive ? (
                <a href={product.url}>
                  <ProductSerializer
                    node={structureTiptapState?.content?.[0] as any}
                    rootClassName={'h-full'}
                    rootStyle={{}}
                    product={product}
                    productVariant={productVariant}
                  />
                </a>
              ) : (
                <ProductSerializer
                  node={structureTiptapState?.content?.[0] as any}
                  rootClassName={'h-full'}
                  rootStyle={{}}
                  product={product}
                  productVariant={productVariant}
                />
              )}
            </div>
          ));
        })}
      </div>

      {children}
    </div>
  );
}
